export const validateInput = (value, rules = {}) => {
	if (value === null || value === undefined || value === '') {
		return { isValid: true, status: 'success', message: '' }
	}

	const { dataType, condition, targetValue, targetCondition } = rules
	
	if (dataType === 'text') {
		if (rules.maxLength && value.length > rules.maxLength) {
			return { isValid: false, status: 'error', message: `ข้อมูลต้องไม่เกิน ${rules.maxLength} ตัวอักษร` }
		}
		return { isValid: true, status: 'success', message: '' }
	}

	const numValue = Number(value)

	// --- 1. Condition Validation (Error - Red) ---

	// Check if it is a number
	if (isNaN(numValue)) {
		return { isValid: false, status: 'error', message: 'กรุณากรอกตัวเลขเท่านั้น' }
	}

	// Integer validation
	if (dataType === 'int') {
		if (!Number.isInteger(numValue)) {
			return { isValid: false, status: 'error', message: 'กรุณากรอกเลขจำนวนเต็ม' }
		}
	}

	// Percentage validation
	const isPercentage = condition?.includes('0.00 - 100.00') || condition?.includes('ร้อยละ')
	if (isPercentage) {
		if (numValue < 0 || numValue > 100) {
			return { isValid: false, status: 'error', message: 'ข้อมูลต้องอยู่ระหว่าง 0 - 100' }
		}
	}

	// Non-negative validation (Default)
	if (numValue < 0) {
		return { isValid: false, status: 'error', message: 'ข้อมูลต้องไม่ต่ำกว่า 0' }
	}

    // Max Value Validation
    if (rules.maxValue !== undefined && numValue > rules.maxValue) {
        return { isValid: false, status: 'error', message: `ข้อมูลต้องไม่เกิน ${rules.maxValue}` }
    }

	// --- 2. Target Validation (Warning - Yellow/Orange) ---
	if (targetValue !== undefined && targetValue !== null && targetCondition) {
		let isTargetMet = true
		const targetNum = Number(targetValue)

		switch (targetCondition) {
			case 'ge': // Greater than or equal (>=)
				isTargetMet = numValue >= targetNum
				break
			case 'le': // Less than or equal (<=)
				isTargetMet = numValue <= targetNum
				break
			case 'gt': // Greater than (>)
				isTargetMet = numValue > targetNum
				break
			case 'lt': // Less than (<)
				isTargetMet = numValue < targetNum
				break
			case 'eq': // Equal (=)
				isTargetMet = numValue === targetNum
				break
			default:
				break
		}

		if (!isTargetMet) {
			return {
				isValid: true, // It's valid data, but warns user
				status: 'warning',
				message: `ค่าที่ได้ไม่เป็นไปตามเป้าหมาย\n(เป้าหมาย: ${targetCondition === 'ge' ? '≥' : targetCondition === 'le' ? '≤' : targetCondition} ${targetValue})`
			}
		}
	}

	return { isValid: true, status: 'success', message: '' }
}
